import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ExportsService {

    constructor(private httpClient: HttpClient) {}

    async export(teamId: string, exportType: string, fileType: string): Promise<{ message: string }> {
        return await firstValueFrom(this.httpClient.get<{message: string}>('/api/exports/' + exportType + '/' + fileType + '/' + teamId));
    }
}